export enum BasketSections {
  QUOTE = 'Quote',
  EXTRAS_CALCULATIONS = 'ExtrasCalculations',
  PROTECTION = 'Protection',
  SERVICE = 'Service',
  ACCOUNT = 'Account',
  PARCELS = 'Parcels',
  EXTRAS = 'Extras',
  DATES = 'Dates',
  ORIGIN = 'Origin',
  DESTINATION = 'Destination',
  CUSTOMS = 'Customs',
  LEGAL = 'Legal',
  META = 'META',
  DISCOUNT = 'DISCOUNT'
}

export enum RequirementTypes {
  ORIGIN = 'origin',
  DESTINATION = 'destination',
  ACCOUNT = 'accountHolder',
  PARCELS = 'parcels',
  PARCEL_CONTENTS = 'parcelContent',
  CUSTOMS = 'customs',
  DELIVERY_INSTRUCTIONS = 'deliveryInstructions'
}

export enum DrawerNavigationType {
  Details = 1,
  DropOff,
  Protection
}
